var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('headers'),_c('div',{staticClass:"main_box"},[_c('router-view')],1),_c('footers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }